import { EngagementData } from '../models/engagement-data.model';
import { EngagementDocument } from '../models/engagement-document';
import { ActionDocumentType } from '../models/enums/action-document-type.enum';
import { EngagementDocumentCounterParty } from '../models/enums/engagement-document-counter-party';
import { EngagementDocumentStatus } from '../models/enums/engagement-document-status';

// A row is the buyer's DD NDA document when it sits in the section/template pair
// configured on the LOI & DD NDA Execution action for this engagement — the same
// identity join used by EventActionAvailabilityHelper.findBuyerDdNdaDocument and
// derive-loi-status.hasExecutedLoiDocument. It's still awaiting the buyer's
// signature while it requires action, is a signable document, and is currently
// on the buyer's leg of the two-party signature.
export const isBuyerDdNdaAwaitingSignature = (
    row: EngagementDocument,
    engagementData: EngagementData | undefined
): boolean => {
    const isDdNdaDocument = (
        engagementData?.loiAndDdNdaExecutionConfigList ?? []
    ).some(
        (config) =>
            row.sectionId === config.ddNdaSectionId &&
            row.templateId === config.ddNdaTemplateId
    );
    if (!isDdNdaDocument) {
        return false;
    }

    return (
        row.status === EngagementDocumentStatus.RequiresAction &&
        row.type === ActionDocumentType.ForSign &&
        row.counterParty === EngagementDocumentCounterParty.Buyer
    );
};
